<script setup lang="ts">
import { splitProps } from 'naive-ui';

const props = defineProps({
  ...splitProps,
  /** Gaia splits are side-by-side panes (review workspace, ticket details). */
  direction: {
    type: String as () => 'horizontal' | 'vertical',
    default: 'horizontal',
  },
  /** Even split by default — neither pane is the subordinate one. */
  defaultSize: {
    type: [Number, String],
    default: 0.5,
  },
  /** Keeps either pane from collapsing to an unusable sliver. */
  min: {
    type: [Number, String],
    default: 0.2,
  },
  max: {
    type: [Number, String],
    default: 0.8,
  },
});
</script>

<template>
  <!-- Resizable two-pane split (review workspace: fields | document). The panes
       go in #1 and #2. A canvas-backed child (the PDF preview) does not reflow
       on its own, so the parent view debounces @update:size and re-keys it. -->
  <n-split v-bind="props">
    <template #1><slot name="1" /></template>
    <template #2><slot name="2" /></template>
    <template v-if="$slots['resize-trigger']" #resize-trigger>
      <slot name="resize-trigger" />
    </template>
  </n-split>
</template>
